function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@mui/material';
import { parseISO } from 'date-fns';
import { AppointmentType } from 'src/@types/Appointment';
import { DataTestIds } from 'src/config/dataTestIds';
import { getClinicLocation, getClinicLocationUrl } from 'src/helpers/clinic';
import { formatMedium, formatTime } from 'src/helpers/date';
import useVisitation from 'src/hooks/api/useVisitation';
import useDateFnsConfig from 'src/hooks/useDateFnsConfig';
import useIsDesktop from 'src/hooks/useIsDesktop';
import * as S from './AppointmentView.styles';
import DesktopView from './components/DesktopView';
import MobileView from './components/MobileView';
const AppointmentView = ({
  type,
  appointmentReferenceId,
  dateOfVisit,
  padded,
  clinic,
  ...rest
}) => {
  const isDesktop = useIsDesktop();
  const {
    t
  } = useTranslation();
  const {
    data: visitation
  } = useVisitation({
    appointmentReferenceId,
    type
  });
  const locale = useDateFnsConfig();
  const date = formatMedium(new Date(dateOfVisit), locale);
  const time = type === AppointmentType.Upcoming ? formatTime(parseISO(dateOfVisit), locale) : null;
  const hasClinicLocation = clinic?.lat && clinic?.long;
  const treatments = visitation?.dentalTreatments || [];
  const View = isDesktop ? DesktopView : MobileView;
  return /*#__PURE__*/React.createElement(S.Root, {
    padded: padded,
    "data-testid": DataTestIds.AppointmentDetailedItem
  }, /*#__PURE__*/React.createElement(View, _extends({
    date: date,
    time: time,
    clinic: clinic,
    treatments: treatments,
    LocationLink: hasClinicLocation ? /*#__PURE__*/React.createElement(Link, {
      href: getClinicLocationUrl(clinic),
      target: "_blank"
    }, getClinicLocation(clinic)) : null,
    labels: {
      treatment: t('b2c.appointments.treatment'),
      date: t('b2c.appointments.appointmentSchedule'),
      viewProfile: t('b2c.appointments.viewProfile'),
      callClinic: t('b2c.appointments.callTheClinic'),
      clinic: t('b2c.appointments.clinic'),
      details: t('b2c.appointments.details'),
      findUs: t('b2c.appointments.findUs')
    }
  }, rest)));
};
export default AppointmentView;